import { TenantSettingsPublicIntegrationsTrackSolidDto } from './tenant-settings-public-integrations-track-solid.dto';

export class TenantSettingsIntegrationsTrackSolidDto extends TenantSettingsPublicIntegrationsTrackSolidDto {
  account?: string | null;
  appKey?: string | null;
  appSecret?: string | null;
  password?: string | null;
}
